import { Spin } from 'antd';
import Axios from 'axios';
import { auth } from '../../../_actions/user_actions';
import { React, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DivCard, DivHorizental, DivVertical } from '../LandingPage/LandingPage';
import { UserProfile } from '../../utils/ProductCard';
import { BtnMargined } from '../DetailProductPage/DetailProductPage';

function MembersPage() {

    const [Members, setMembers] = useState([]);
    const [Candidates, setCandidates] = useState([]);
    const [BlankMessage, setBlankMessage] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        const variables = {
            // skip: Skip,
            // limit: Limit,
        };

        getMembers(variables);
    }, []); // , [Limit, Skip]);

    const renderCandidates = (users) => users.map((user, i) => {
        return <DivCard key={i + ']' + user._id}><DivHorizental>
            <UserProfile user={user} style={{ width: '25%', overflow: 'hidden' }}/>
            <DivVertical style={{ width: '100%', overflow: 'hidden' }}>
                <DivHorizental style={{ marginLeft: 'auto' }}>
                    <BtnMargined size='small' danger onClick={evnt => {
                        if (window.confirm('신청을 거절하시겠습니까?')) {
                            Axios.delete('/api/product/candidates/' + user._id + '/' + user.productApplied?._id)
                                .then(response => {
                                    if (response.data.success) {
                                        //삭제 완료 리프레시
                                        getMembers();
                                    }
                                    else alert(response.data.reason);
                                })
                                .catch(err => console.log(err));
                        }
                    }}>거절</BtnMargined>

                    <BtnMargined size='small' type='primary' onClick={evnt => {
                        Axios.put('/api/product/members/' + user.productApplied?._id, { targetUserId: user._id })
                            .then(response => {
                                if (response.data.success) {
                                    //추가 완료 리프레시
                                    getMembers();
                                    dispatch(auth());
                                }
                                else alert(response.data.reason);
                            })
                            .catch(err => console.log(err));
                    }}>수락</BtnMargined>

                </DivHorizental>
                <h4>
                    {user.productApplied?.title}
                </h4>
                <label style={{ height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {user.email}
                </label>
            </DivVertical>
        </DivHorizental></DivCard>;
    });

    const renderMembers = (users) => users.map((user, i) => {
        return <DivCard key={i + ']' + user._id}><DivHorizental>
            <UserProfile user={user} />
            <DivVertical style={{ width: '100%', overflow: 'hidden' }}>
                <DivHorizental style={{ marginLeft: 'auto' }}>
                    <BtnMargined size='small' danger onClick={evnt => {
                        if (window.confirm('정말로 삭제하시겠습니까?')) {
                            Axios.delete('/api/product/members/' + user._id + '/' + user.productApplied?._id)
                                .then(response => {
                                    if (response.data.success) {
                                        //삭제 완료 리프레시
                                        getMembers();
                                    }
                                    else alert(response.data.reason);
                                })
                                .catch(err => console.log(err));
                        }
                    }}>삭제</BtnMargined>
                </DivHorizental>
                <h4>
                    {user.productApplied?.title}
                </h4>
                <label style={{ height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {user.email}
                </label>
            </DivVertical>
        </DivHorizental></DivCard>;
    });

    const getMembers = (variables) => {
        Axios.post('/api/product/getMyProducts', variables)
            .then(response => {
                if (response.data.success) {
                    const myProducts = response.data.products;

                    const myCandidates = myProducts.reduce((acc, currProduct) => {
                        const markedCandidates = currProduct.candidates.map(candidate => {
                            candidate.productApplied = currProduct;
                            return candidate;
                        });
                        return [...acc, ...markedCandidates];
                    }, []);

                    const myMembers = myProducts.reduce((acc, currProduct) => {
                        for (const member of currProduct.members) {
                            if (!acc.includes(member)) {
                                member.productApplied = currProduct;
                                acc.push(member);
                            }
                        }
                        return acc;
                    }, []);

                    let totalMembers, totalCandidates;
                    if (variables?.loadMore) {
                        totalMembers = [...Members, ...myMembers];
                        totalCandidates = [...Candidates, ...myCandidates];
                    } else {
                        totalMembers = myMembers;
                        totalCandidates = myCandidates;
                    }
                    setCandidates(totalCandidates);
                    setMembers(totalMembers);
                    if (!totalMembers?.length && !totalCandidates?.length) setBlankMessage('아직 멤버가 없습니다. 프로젝트를 등록해서 멤버를 모집하거나, 원하는 프로젝트에 먼저 참여 신청해보세요.')

                } else {
                    console.log('Failed to fectch datas');
                }
            })
            .catch(err => console.log(err));
    };

    return <div className='page'>
        {Candidates?.length > 0 && <p style={{ marginBottom: 8 }}> 참여신청 목록({Candidates.length}명) </p>}
        {Candidates && renderCandidates(Candidates)}
        <br />
        <p style={{ marginBottom: 8 }}> 멤버 목록({Members.length}명) </p>
        {Members?.length ?
            renderMembers(Members)
            :
            <h3>{BlankMessage || <Spin />}</h3>
        }
    </div>;
}

export default MembersPage;